import React, { FC } from 'react';
import { useHistory } from 'react-router';
import { Route, Switch } from 'react-router-dom';

import { useSetMfaV1Breadcrumbs } from 'src/apps/mfa-v1/hooks/useSetMfaV1Breadcrumbs';
import { RoutesHelper } from 'src/common/helpers/RoutesHelper';
import { ProductType } from 'src/common/interfaces/Tenant';
import { useUserTenant } from 'src/common/providers/userTenantProvider/UserTenantProvider';
import { hasLicenseForProduct } from 'src/common/services/CommonDashboardService';

import { NotFound404Page } from '../../../common/pages/not-found-404-page/NotFound404Page';
import { Unauthorized403Page } from '../../../common/pages/unauthorized-403-page/Unauthorized403Page';
import { getSessionIdParam } from '../../../common/services/breadcrumbs/MfaUrlService';
import { HtmlReport } from '../../mobile-common/pages/html-report/HtmlReport';
import { DashboardContainerMfa } from '../pages/dashboard-container/DashboardContainerMfa';

const productType = ProductType.MOBILE_FLOW_ANALYZER;

const MfaV1SessionReportSessionGate: FC = () => {
	const { tenant } = useUserTenant();
	const { location } = useHistory();
	const hasLicense = hasLicenseForProduct(tenant, productType);

	const sessionId = getSessionIdParam(location);

	useSetMfaV1Breadcrumbs();

	return hasLicense ? <HtmlReport sessionId={sessionId} /> : <Unauthorized403Page />;
};

export const MfaV1Router: FC = () => {
	return (
		<Switch>
			<Route exact path={RoutesHelper.getMfaV1DashboardPath()} component={DashboardContainerMfa} />
			<Route
				exact
				path={RoutesHelper.getMfaV1SessionReportPathname()}
				render={() => <MfaV1SessionReportSessionGate />}
			/>
			<Route render={() => <NotFound404Page />} />
		</Switch>
	);
};
